import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './styles';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClearSharpIcon from '@material-ui/icons/ClearSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import Popper from '@material-ui/core/Popper';
import StyledDialog from '../../../../../../../common/models/Dialog';

//func
import {
  fetchBOMConsumptionDetails,
  updateConsumption,
  fetchDSBatchDetails,
  fetchBatchDetails,
  fetchBOMDetails,
  fetchVarianceThresholdDetails,
} from '../../../../../../containers/actions/common/saslAction';
import {
  presentFormatedData,
  presentDate,
} from '../../../../functionalComponents/dataFormatFunctions';
//files
import StyledButton from '../../../../models/Button';

import { loadTableData } from '../../../../../../containers/actions/common/fileActions';

// Backdrop while updating
import Backdrop from '../../../../models/BackDrop';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputNumber from '../../../../models/inputs/InputNumber';
import clsx from 'clsx';
import {
  getVariance,
  getVariancePercentage,
  getThreshold,
  getRefQty,
  getStdQty,
  getStockValue,
  getExpiredDate,
} from '../../../common/variance';
import LongTextDisplay from '../../../../models/LongText';
import { PDFViewer } from './PDFViewer';
import Header from './Header';
import { Box, DialogContent } from '@material-ui/core';
import VarianceAlertDialog from '../Consumption/VarianceAlertDialog';
import varianceAlertWrapper from './varianceAlertWrapper';

const PopperAutoSelect = function (props) {
  return (
    <Popper
      {...props}
      style={{ width: 'fit-content', minWidth: 300 }}
      placement='bottom-start'
    />
  );
};

class UpdateBMRData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      batchData: {},
      isUpdateInfoDialog: false,
      resError: null,
      error: false,
      selectedItems: [],
      bomData: {},
      thresholdData: {},
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;

    const data = {
      schrockenDeliveryScheduleBatchID: parseInt(this.props.schrockenDeliveryScheduleBatchID),
      schrockenDeliveryScheduleID: this.props.schrockenDeliveryScheduleID,
      bomConsumptionAddedIndicator: this.props.batchDetails.bomConsumptionAddedIndicator,
    };

    const bomRecipeFetch = {
      schrockenDeliveryScheduleID: parseInt(this.props.schrockenDeliveryScheduleID),
    };

    this.props.fetchBOMConsumptionDetails(data);
    this.props.fetchBOMDetails(bomRecipeFetch);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.consumptionDetails !== prevProps.consumptionDetails &&
      this.props.consumptionDetails.status === true
    ) {
      if (this._isMounted) {
        this.setState({
          loading: false,
          batchData: this.props.consumptionDetails.data,
        });
      }
      this.formatConsumptionData(this.props.consumptionDetails.data.bomConsumptionDetails);
    }

    if (
      this.props.updateBOM !== prevProps.updateBOM &&
      this.props.updateBOM.status === true
    ) {
      if (this._isMounted) {
        this.setState({
          isUpdateInfoDialog: true,
          resError: null,
        });
      }
    }

    if (
      this.props.updateBOM !== prevProps.updateBOM &&
      this.props.updateBOM.status === false
    ) {
      if (this._isMounted) {
        const errorDesc = this.props.updateBOM.errorDescription;
        if (typeof errorDesc === 'object') {
          const errorKey = Object.keys(errorDesc)[0];
          this.setState({ resError: errorDesc[errorKey] });
        } else {
          this.setState({ resError: errorDesc });
        }
        this.scrollToTop();
      }
    }

    if (
      this.props.viewBOM !== prevProps.viewBOM &&
      this.props.viewBOM.status === true
    ) {
      if (this._isMounted) {
        this.setState({
          bomData: this.props.viewBOM.data,
        });
      }
    }

    if (
      this.props.thresholdValue !== prevProps.thresholdValue &&
      this.props.thresholdValue.status === true
    ) {
      if (this._isMounted) {
        this.setState({
          thresholdData: this.props.thresholdValue.data,
        });
      }
    }
  }

  scrollToTop = () => {
    this.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  varianceCheck = () => {
    this.props.varianceAlertWrapper({
      schrockenDeliveryScheduleBatchID:
        this.props.batchDetails.schrockenDeliveryScheduleBatchID,
      targetQuantity: this.props.targetQuantity,
    })
      .then((res) => {
        if (res.exceedVariance === true || res.lotMismatch === true) {
          this.setState({
            varianceThresholdAlertScreen: true,
            exceedVariance: res.exceedVariance,
            lotMismatch: res.lotMismatch,
          });
        } else {
          this.props.handleClose()
        }
        // else if (localStorage.collabType === 'CMO') {
        //   this.handleSubmit()
        // } else {
        //   this.handleSubmit()
        // }
      })
      .catch((err) => {
        this.setState({
          resError:
            err?.errMessage || 'Something went wrong. Please try again later',
        });
        this.scrollToTop();
      });
  };

  handleCloseVarianceAlert = () => {
    this.setState({
      varianceThresholdAlertScreen: false,
    });
  }

  handleCloseDialog = () => {
    this.setState({
      isUpdateInfoDialog: !this.state.isUpdateInfoDialog,
    });
    this.varianceCheck()
    // this.props.handleClose();
    // this.props.handleFetchCall();
  };

  addCustomRow = (componentData) => {
    let consumptionData = {
      componentBatchNumber: '',
      BomComponentConsumedQuantity: '',
      componentBatchNumberCMO: '',
      bomComponentConsumedQuantityCMO: '',
      newField: true,
    };
    // TO DO: ADD find index as separate func
    let { data } = this.state;
    let indexofComponent = data.findIndex(
      (ele) => ele.BomComponentCode === componentData.BomComponentCode
    );
    let addEmptyRow = true;

    for (
      let j = 0;
      j < data[indexofComponent].consumptionBatchNumbers.length;
      j++
    ) {
      if (
        data[indexofComponent].consumptionBatchNumbers[j]
          .BomComponentConsumedQuantity === '' ||
        data[indexofComponent].consumptionBatchNumbers[j]
          .BomComponentConsumedQuantity === 0 ||
        isNaN(
          data[indexofComponent].consumptionBatchNumbers[j]
            .BomComponentConsumedQuantity
        ) ||
        data[indexofComponent].consumptionBatchNumbers[j]
          .componentBatchNumber === ''
      ) {
        addEmptyRow = false;
      }
    }

    if (addEmptyRow) {
      this.setState(({ data }) => ({
        data: [
          ...data.slice(0, indexofComponent),
          {
            ...data[indexofComponent],
            consumptionBatchNumbers: [
              ...data[indexofComponent].consumptionBatchNumbers,
              consumptionData,
            ],
          },
          ...data.slice(indexofComponent + 1),
        ],
        resError: null,
      }));
    }
  };

  removeBatchConsumption = (
    componentData,
    consumptionData,
    consumptionDataIndex
  ) => {
    let { data } = this.state;

    let indexofComponent = data.findIndex(
      (ele) => ele.BomComponentCode === componentData.BomComponentCode
    );

    // selectedItems.pop(consumptionData.componentBatchNumber);

    let newData = [
      ...data.slice(0, indexofComponent),
      {
        ...data[indexofComponent],
        consumptionBatchNumbers: [
          //TO DO: change the slice approach to proper array removal method
          ...data[indexofComponent].consumptionBatchNumbers.slice(
            0,
            consumptionDataIndex
          ),
          ...data[indexofComponent].consumptionBatchNumbers.slice(
            consumptionDataIndex + 1
          ),
        ],
      },
      ...data.slice(indexofComponent + 1),
    ];
    this.setState({
      data: newData,
      resError: null,
    });
  };

  handleChange = (event, componentData, consumptionDataIndex) => {
    let { name, value } = event.target;
    let { data } = this.state;

    if (value < 0) {
      alert('invalid quantity');
    } else {
      let indexofComponent = data.findIndex(
        (ele) => ele.BomComponentCode === componentData.BomComponentCode
      );

      this.setState(({ data }) => ({
        data: [
          ...data.slice(0, indexofComponent),
          {
            ...data[indexofComponent],
            consumptionBatchNumbers: [
              ...data[indexofComponent].consumptionBatchNumbers.slice(
                0,
                consumptionDataIndex
              ),
              {
                ...data[indexofComponent].consumptionBatchNumbers[
                consumptionDataIndex
                ],
                [name]: parseFloat(value),
                BomComponentConsumedQuantity: parseFloat(value),
              },
              ...data[indexofComponent].consumptionBatchNumbers.slice(
                consumptionDataIndex + 1
              ),
            ],
          },
          ...data.slice(indexofComponent + 1),
        ],
        error: false,
        resError: null,
      }));
    }
  };

  handleSubmit = () => {
    let { data } = this.state;
    let batchNumberFilled = true;
    let testingArray = [];
    let duplicateVariable = false;


    for (let i = 0; i < data.length; i++) {
      // eslint-disable-next-line
      data[i].consumptionBatchNumbers.forEach((details) => {
        if (
          details.bomComponentConsumedQuantityCMO === '' ||
          details.bomComponentConsumedQuantityCMO === ' ' ||
          isNaN(details.bomComponentConsumedQuantityCMO)
        ) {
          details.bomComponentConsumedQuantityCMO = 0;
        } else if (
          (details.bomComponentConsumedQuantityCMO > 0 &&
            details.componentBatchNumberCMO === '') ||
          (details.bomComponentConsumedQuantityCMO > 0 &&
            details.componentBatchNumberCMO === ' ')
        ) {
          this.setState({
            resError:
              'Please select batch number for respective consumed quantity',
          });
          batchNumberFilled = false;
          this.scrollToTop();
        }
      });
      if (!data[i].remarks) {
        data[i].remarks = '';
      }
      if (!data[i].remarksBO) {
        data[i].remarksBO = '';
      }
      this.setState({ data });
    }

    for (let i = 0; i < data.length; i++) {
      data[i].consumptionBatchNumbers.forEach((details) => {
        if (details.componentBatchNumberCMO !== '') {
          testingArray.push(details.componentBatchNumberCMO);
        } else {
          console.error('push not happening');
        }
      });
    }

    function checkForDuplicates(array) {
      return new Set(array).size !== array.length;
    }

    if (!checkForDuplicates(testingArray)) {
      // this.setState({
      //   resError: 'passed',
      // });
      duplicateVariable = false;
    } else if (batchNumberFilled) {
      duplicateVariable = true;
      this.setState({
        resError:
          'Same Batch Number has been selected for different consumption quantity',
      });
      this.scrollToTop();
    }

    let apiData = {
      bomConsumptionDetails: [
        {
          vendorMosymphonyID: this.props.batchDetails.vendorMosymphonyID,
          vendorBatchNumber: this.state.batchData.vendorBatchNumber,
          schrockenDeliveryScheduleBatchID:
            this.props.schrockenDeliveryScheduleBatchID,
          schrockenDeliveryScheduleID: this.props.schrockenDeliveryScheduleID,
          BOMConsumptionDetails: this.state.data,
        },
      ],
    };

    if (batchNumberFilled === true && duplicateVariable === false) {
      this.props.updateConsumption(apiData);
    } else {
      console.error('consumption updating error in UI');
    }
  };

  formatConsumptionData = (data) => {
    let consumptionData = [
      {
        componentBatchNumber: '',
        BomComponentConsumedQuantity: '',
        inventoryBatchNumber: '',
        materialCode: '',
        valuatedUnrestrictedUsedStock: '',
        inventoryExpiryDate: '',
      },
    ];

    for (let i = 0; i < data.length; i++) {
      if (
        !data[i].consumptionBatchNumbers ||
        data[i].consumptionBatchNumbers.length === 0
      ) {
        data[i]['consumptionBatchNumbers'] = consumptionData;
      }
    }
    this.setState({ data });
  };
  handleChangeSelect = (dropDownValue, componentData, consumptionDataIndex) => {
    let { data } = this.state;
    let indexofComponent = data.findIndex(
      (ele) => ele.BomComponentCode === componentData.BomComponentCode
    );

    if (dropDownValue) {
      // selectedItems.push(dropDownValue.inventoryBatchNumber);
      this.setState(({ data }) => ({
        data: [
          ...data.slice(0, indexofComponent),
          {
            ...data[indexofComponent],
            consumptionBatchNumbers: [
              ...data[indexofComponent].consumptionBatchNumbers.slice(
                0,
                consumptionDataIndex
              ),
              {
                ...data[indexofComponent].consumptionBatchNumbers[
                consumptionDataIndex
                ],
                componentBatchNumberCMO: dropDownValue.inventoryBatchNumberCMO,
                materialCodeCMO: dropDownValue.materialCodeCMO,
                componentBatchNumber: dropDownValue.inventoryBatchNumber,
                materialCode: dropDownValue.materialCode,
                // componentBatchNumber: '',
                // materialCode:"",
                valuatedUnrestrictedUsedStock:
                  dropDownValue.valuatedUnrestrictedUsedStock,
                inventoryExpiryDate: dropDownValue.inventoryExpiryDate,
              },
              ...data[indexofComponent].consumptionBatchNumbers.slice(
                consumptionDataIndex + 1
              ),
            ],
          },
          ...data.slice(indexofComponent + 1),
        ],
        error: false,

        resError: null,
      }));
    }
  };

  /* Need this func to disable few options based on a condition */

  // disbaleAlreadySelectedItems = (disbaledValue) => {
  //   let { selectedItems } = this.state;
  //   return selectedItems.some((x) => x === disbaledValue);
  // };
  // handleRemarks = (event, index) => {
  //   const { data } = this.state;
  //   data[index]['remarks'] = event.target.value;
  //   this.setState({ data: data });
  // };

  // handleBORemarks = (event, index) => {
  //   const { data } = this.state;
  //   data[index]['remarksBO'] = event.target.value;
  //   this.setState({ data: data });
  // };
  render() {
    const { handleClose, classes, schrockenCustomFileID, open,
      onClose,
      batchDetails,
      viewFlag } = this.props;
    const {
      data,
      loading,
      batchData,
      isUpdateInfoDialog,
      resError,
      // error,
      bomData,
      thresholdData,
    } = this.state;
    const { SASLBatchStatusID } = this.props.batchDetails;

    return (
      <Dialog fullScreen open={open} onClose={onClose}>
        <Header
          title={viewFlag || localStorage.collabType !== 'CMO' ? 'Consumption Details' : 'BMR - Check and update'}
          isButtonsExist={!viewFlag && localStorage.collabType === 'CMO'}
          handleClose={onClose}
          // handleSubmit={this.varianceCheck}
          handleSubmit={this.handleSubmit}
        >


          <DialogContent
            style={{ overflowY: 'hidden' }}
            ref={(el) => {
              this.el = el;
            }}
          >
            <Backdrop />
            <Grid
              container
              justifyContent='center'
              style={{
                padding: '1rem 0',
                display: resError === null && 'none',
              }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Typography
                  variant='h6'
                  style={{
                    border: '1px solid #FF0000',
                    backgroundColor: '#FFF0F0',
                    opacity: '1',
                    textAlign: 'center',
                    padding: '0.8rem',
                    fontSize: '0.875rem',
                  }}
                >
                  {resError}
                </Typography>
              </Grid>
            </Grid>
            <Box mt={2}>
              <Grid container spacing={3}>
                {/* Left Panel - COA Data */}
                <Grid item xs={12} md={6}>
                  <Paper elevation={3}>
                    <Box
                      p={3}
                      display="flex"
                      justifyContent="space-between"
                      borderBottom={1}
                      borderColor="grey.300"
                    >
                      <Typography variant="h6">Consumption Table</Typography>
                    </Box>
                    {/* {error && (
                  <Box
                    style={{
                      border: "2px solid rgb(255,0,0)",
                      backgroundColor: "rgb(255,240,240)",
                      Opacity: 1,
                      textAlign: "center",
                      padding: "0.8rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    <Typography>
                      Something went wrong. Please try again later.
                    </Typography>
                  </Box>
                )} */}
                    <Box p={2}>
                      <React.Fragment>
                        <Grid container justify='center' className={classes.contain}>
                          <React.Fragment>
                            {loading === true ? (
                              <Grid container justify='center'>
                                <div
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '10%',
                                    minWidth: '60vw',
                                    paddingBottom: '8rem',
                                  }}
                                >
                                  <CircularProgress color='primary' thickness={7} />
                                </div>
                              </Grid>
                            ) : (
                              <TableContainer component={Paper} style={{ overflowY: 'hidden' }}>
                                <Table stickyHeader className={classes.table} aria-label='simple table'>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell style={{ paddingRight: '24px' }}>Material Code / Description</TableCell>
                                      <TableCell align='right' style={{ paddingRight: '24px' }}>
                                        BoM Quantity
                                      </TableCell>
                                      <TableCell style={{ paddingRight: '24px' }}>UOM</TableCell>
                                      <TableCell style={{ paddingRight: '24px' }}>Actual Quantity Consumed</TableCell>
                                      <TableCell align='left' style={{ whiteSpace: 'nowrap' }}>Batch Nos.</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data.map((row, bomIndex) => {
                                      let refQty;
                                      if (batchData?.bomComponentDetails) {
                                        refQty = getRefQty({
                                          materialCode: localStorage.collabType === 'CMO' ? row.bomComponentCodeCMO : row.BomComponentCode,
                                          bomData: batchData.bomComponentDetails,
                                        });
                                      } else {
                                        refQty = getRefQty({
                                          materialCode: row.BomComponentCode,
                                          bomData: bomData.bomComponentDetails,
                                        });
                                      }

                                      let stdQty;
                                      if (batchData?.fgRefQuantity) {
                                        stdQty = getStdQty(
                                          batchData.batchSize,
                                          presentFormatedData(batchData.fgRefQuantity),
                                          refQty
                                        );
                                      } else {
                                        stdQty = getStdQty(
                                          batchData.batchSize,
                                          presentFormatedData(bomData.fgRefQuantity),
                                          refQty
                                        );
                                      }

                                      let expiredDate = getExpiredDate(
                                        row.consumptionBatchNumbers,
                                        row.inventoryBatches
                                      );

                                      let currentDate = new Date().toISOString();

                                      return (
                                        <React.Fragment key={`consum-row-${bomIndex}`}>
                                          <TableRow key={`consum-row-${bomIndex}`}>
                                            {localStorage.collabType === 'CMO' ?
                                              <TableCell style={{ paddingRight: '24px' }}>
                                                {row.bomComponentCodeCMO} / {row.BomComponentName}
                                              </TableCell>
                                              : <TableCell style={{ paddingRight: '24px' }}>
                                                {row.BomComponentCode} / {row.BomComponentName}
                                              </TableCell>
                                            }

                                            <TableCell align='right' style={{ paddingRight: '24px' }}>
                                              {presentFormatedData(stdQty, '')}
                                            </TableCell>

                                            {localStorage.collabType === 'CMO' ?
                                              <TableCell style={{ paddingRight: '24px' }}>
                                                {row.bomComponentRefUOMCMO}
                                              </TableCell> :
                                              <TableCell style={{ paddingRight: '24px' }}>
                                                {row.BomComponentRefUOM}
                                              </TableCell>
                                            }

                                            <TableCell style={{ paddingRight: '24px' }}>
                                              {row.consumptionBatchNumbers.map((consumptionData, index) => {
                                                let stockValue = getStockValue(
                                                  consumptionData,
                                                  row.inventoryBatches
                                                );
                                                return (
                                                  <div
                                                    key={`consum-${index}`}
                                                    className={classes.tdConsumption}
                                                  >
                                                    {localStorage.collabType === 'CMO' &&
                                                      (SASLBatchStatusID < 6 ||
                                                        SASLBatchStatusID === 13 ||
                                                        SASLBatchStatusID === 15) && !viewFlag ? (
                                                      <InputNumber
                                                        onWheel={(e) => e.target.blur()}
                                                        className={classes.warningStyles}
                                                        style={{
                                                          width: consumptionData?.bomComponentConsumedQuantityCMO
                                                            ? Math.max(75, (String(consumptionData?.bomComponentConsumedQuantityCMO).length * 10) + 40) + "px"
                                                            : '100%'
                                                        }}
                                                        name={'bomComponentConsumedQuantityCMO'}
                                                        value={consumptionData?.bomComponentConsumedQuantityCMO}
                                                        placeholder='Consumed Quantity'
                                                        onChange={(event) => this.handleChange(event, row, index)}
                                                        helperText={
                                                          consumptionData.bomComponentConsumedQuantityCMO > stockValue
                                                            ? 'Consumed quantity exceeds the available stock '
                                                            : ''
                                                        }
                                                        classes={{
                                                          root: classes.inputPlaceholder,
                                                        }}
                                                      />
                                                    ) : (
                                                      <>
                                                        {localStorage.collabType === 'CMO' ?
                                                          consumptionData.bomComponentConsumedQuantityCMO
                                                          : consumptionData.BomComponentConsumedQuantity
                                                        }
                                                      </>
                                                    )}
                                                  </div>
                                                );
                                              })}
                                            </TableCell>

                                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                              {row.consumptionBatchNumbers.map((consumptionData, index) => (
                                                <div
                                                  key={`Autocomplete-${index}`}
                                                  className={clsx(classes.tdConsumption, classes.tdAuto)}
                                                >
                                                  {localStorage.collabType === 'CMO' &&
                                                    (SASLBatchStatusID < 6 ||
                                                      SASLBatchStatusID === 13 ||
                                                      SASLBatchStatusID === 15) && !viewFlag ? (
                                                    <Autocomplete
                                                      disableClearable
                                                      size='small'
                                                      value={consumptionData}
                                                      options={
                                                        row.inventoryBatches.length > 0
                                                          ? [{
                                                            inventoryBatchNumber: 'Batch No.',
                                                            inventoryBatchNumberCMO: 'Batch No.',
                                                            inventoryExpiryDate: 'Exp Date',
                                                            valuatedUnrestrictedUsedStock: 'Stock',
                                                          }, ...row.inventoryBatches]
                                                          : []
                                                      }
                                                      PopperComponent={PopperAutoSelect}
                                                      className={classes.autoComplete}
                                                      getOptionLabel={(option) =>
                                                        option.inventoryBatchNumberCMO
                                                          ? option.inventoryBatchNumberCMO
                                                          : option.componentBatchNumberCMO
                                                      }
                                                      getOptionSelected={(option, value) =>
                                                        option.inventoryBatchNumberCMO === value.componentBatchNumberCMO
                                                      }
                                                      getOptionDisabled={(option) =>
                                                        option.inventoryBatchNumber === 'Batch No.' ||
                                                        option.inventoryBatchNumberCMO === 'Batch No.'
                                                      }
                                                      noOptionsText='No Batch Numbers Available'
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          label='Select Batch From Stock'
                                                          variant='outlined'
                                                          className={classes.warningStyles}
                                                          helperText={
                                                            currentDate >= expiredDate ? 'Expired Batch ' : ''
                                                          }
                                                          InputLabelProps={{
                                                            style: { fontSize: '0.875rem' },
                                                          }}
                                                        />
                                                      )}
                                                      renderOption={(option) => (
                                                        <Grid container>
                                                          <Grid item xs={5} className={classes.wrapText}>
                                                            {option.inventoryBatchNumberCMO}
                                                          </Grid>
                                                          <Grid item xs={4} className={classes.wrapText}>
                                                            {option.valuatedUnrestrictedUsedStock}
                                                          </Grid>
                                                          <Grid item xs={3} className={classes.wrapText}>
                                                            {presentDate(option.inventoryExpiryDate, 'Expiry Date')}
                                                          </Grid>
                                                        </Grid>
                                                      )}
                                                      onChange={(event, newValue) => {
                                                        this.handleChangeSelect(newValue, row, index);
                                                      }}
                                                    />
                                                  ) : (
                                                    <>
                                                      {localStorage.collabType === 'CMO' ?
                                                        consumptionData.componentBatchNumberCMO :
                                                        consumptionData.componentBatchNumber}
                                                    </>
                                                  )}
                                                  <div
                                                    title={index === 0 ? 'Add Batch' : 'Remove Batch'}
                                                    placement='right-start'
                                                  >
                                                    {index === 0
                                                      ? ((localStorage.collabType === 'CMO' && SASLBatchStatusID < 6) ||
                                                        SASLBatchStatusID === 13) && !viewFlag && (
                                                        <Fab
                                                          style={{ marginLeft: '8px' }}
                                                          size='small'
                                                          fontSize='small'
                                                          color='secondary'
                                                          aria-label='Add new batch number'
                                                          onClick={() => this.addCustomRow(row)}
                                                        >
                                                          <AddIcon />
                                                        </Fab>
                                                      )
                                                      : ((localStorage.collabType === 'CMO' && SASLBatchStatusID < 6) ||
                                                        SASLBatchStatusID === 13) && !viewFlag && (
                                                        <div style={{ paddingLeft: '1rem' }}>
                                                          <ClearSharpIcon
                                                            fontSize='small'
                                                            color='error'
                                                            className={classes.icon}
                                                            onClick={() => this.removeBatchConsumption(row, consumptionData, index)}
                                                          />
                                                        </div>
                                                      )}
                                                  </div>
                                                </div>
                                              ))}
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )}
                          </React.Fragment>
                        </Grid>
                        <Dialog open={isUpdateInfoDialog} fullWidth>
                          <StyledDialog
                            icons={true}
                            handleClose={this.handleCloseDialog}
                            title='Details Saved'
                          />
                        </Dialog>
                      </React.Fragment>
                    </Box>
                  </Paper>
                </Grid>

                {/* Right Panel - PDF Viewer */}
                <Grid item xs={12} md={6}>
                  <Paper elevation={3}>
                    <Box p={3} borderBottom={1} borderColor="grey.300">
                      <Typography variant="h6">Scanned Document</Typography>
                    </Box>
                    <Box p={3}>
                      {schrockenCustomFileID ?
                        <PDFViewer schrockenCustomFileID={schrockenCustomFileID} />
                        :
                        <Box
                          style={{
                            // border: "2px solid rgb(255,0,0)",
                            // backgroundColor: "rgb(255,240,240)",
                            Opacity: 1,
                            textAlign: "center",
                            padding: "0.8rem",
                            fontSize: "0.875rem",
                          }}
                        >
                          <Typography>
                            No File uploaded
                          </Typography>
                        </Box>
                      }

                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>

        </Header>
        <Dialog
          open={this.state.varianceThresholdAlertScreen}
          fullWidth
        >
          <VarianceAlertDialog
            icons={true}
            // handleYesButton={this.handleSubmit}
            handleYesButton={() => this.props.handleClose()}
            handleClose={this.handleCloseVarianceAlert}
            handleNoButton={this.handleCloseVarianceAlert}
            // errors={errors}
            title={this.state.exceedVariance && this.state.lotMismatch
              ? 'Quantity variance and batch mismatch alert'
              : this.state.exceedVariance
                ? 'Quantity variance alert'
                : 'Batch mismatch alert'}
            subtitle={this.state.exceedVariance && this.state.lotMismatch
              ? `There are materials that have crossed the allowed variance limit and
are not matching with the recommended batch allocation numbers.
Please confirm if you still want to proceed. `
              : this.state.exceedVariance
                ? `There are materials that have crossed the allowed variance limit.
Please confirm if you still want to proceed.`
                : `There are materials that are not matching with the recommended batch allocation numbers.
Please confirm if you still want to proceed.`}
          />
        </Dialog>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({
  consumptionDetails: state.pcmp.common.sasl.consumptionInfo,
  updateBOM: state.pcmp.common.sasl.updateBOM,

  backDropLoading: state.pcmp.common.files.backdropLoading,
  viewBOM: state.pcmp.common.sasl.viewBOM,
  thresholdValue: state.pcmp.common.sasl.fetchVarianceThreshold,
});

export default withStyles(useStyles)(
  connect(mapStateToProps, {
    fetchBOMConsumptionDetails,
    updateConsumption,
    fetchBatchDetails,
    fetchDSBatchDetails,
    fetchBOMDetails,
    loadTableData,
    fetchVarianceThresholdDetails,
    varianceAlertWrapper,
  })(UpdateBMRData)
);
